import React from 'react';
import propTypes from 'prop-types';
import {connect} from 'react-redux';
import lang from '../../constants/Languages.js';
import Tree from 'react-d3-tree';

const ItemTree = ({ clang }) => {
    const myTreeData = [
      {
        name: 'movie',
        attributes: {
          id: '1',
          type: 'movie',
        },
        children: [
          {
            name: 'book',
            attributes: {
              id: '1',
              type: 'book',
            },
            children: [
              {
                name: 'institution',
                attributes: {
                  id: '1',
                  type: 'institution',
                },
              },
              {
                name: 'person',
                attributes: {
                  id: '1',
                  type: 'person',
                },
              },
            ],
          },
          {
            name: 'journal',
            attributes: {
              id: '1',
              type: 'journal',
            },
          },
        ],
      },
    ];

    const click = (e) => {
      console.log(e)
    };

    const addPerson = () => {
      myTreeData[0].children.push({name: 'person2', attributes: {id: '2', type: 'pesron'}})
    };
    return (
      <div className="item-tree">
        <div id="treeWrapper" className="item-tree__wrapper">
          <Tree data={myTreeData} translate={{x: 20, y: 200}} zoom={0.6} onClick={click}/>
        </div>
        <button onClick={addPerson}>add</button>
      </div>
    );
};


ItemTree.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ItemTree);



// WEBPACK FOOTER //
// ./src/components/items/ItemTree.js